import styled from 'styled-components';
import imageHelper from '@utils/imageHelper';
import Button from '@base/Button/Button';
import BackgroundImage from './BackgroundImage';

const StyledBackgroundImage = styled(BackgroundImage)`
  @media (min-width: 70.95em) {
    left: 0;
  }
`;

const MissionGroup = styled.div`
  width: 576px;
  position: relative;
  padding-top: 64px;
  @media (max-width: 70.95em) {
    width: 100%;
    padding: 0px;
  }
  @media (max-width: 70.95em) {
    margin-top: 40px;
  }
`;

const Options = styled(Button)`
  @media (max-width: 70.95em) {
    margin: auto;
    width: 241px;
    height: 57px;
    font-size: 20px;
    line-height: 120%;
    font-weight: 600;
  }
`;

const Mission = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 2px;
  color: #08bd80;
  @media (max-width: 70.95em) {
    font-size: 12px;
    text-align: center;
    display: block;
  }
  @media (max-width: 70.95em) {
    padding-top: 34px;
  }
`;

const Roles = styled.div`
  font-size: 16px;
  line-height: 150%;
  color: #627984;
  margin-top: 32px;
  margin-bottom: 16px;
  display: block;
  @media (max-width: 70.95em) {
    text-align: center;
    margin: 16px 0 32px;
  }
`;

const Description = styled.h2`
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: #3c4852;
  margin-top: 16px;
  @media (max-width: 70.95em) {
    font-size: 24px;
    text-align: center;
  }
`;

const Image = styled.img`
  width: 560px;
  height: 424px;
  position: absolute;
  right: 0;
  top: 0px;
  object-fit: cover;
  @media (max-width: 70.95em) {
    grid-column: span 24;
    width: 100%;
    height: 282px;
    position: relative;
    margin-top: 40px;
  }
`;

const JoinUs = styled.div`
  grid-column: span 24;
  height: 424px;
  position: relative;
  padding-top: 40px;
  padding-left: 48px;
  display: flex;
  box-shadow: 0px 16px 32px rgba(221, 230, 237, 0.4);
  border-radius: 8px;
  margin-top: 4px;
  overflow: hidden;
  @media (max-width: 70.95em) {
    grid-column: span 12;
    flex-direction: column-reverse;
    flex-wrap: wrap;
    height: auto;
  }
  @media (max-width: 70.95em) {
    width: 100%;
    grid-column: span 24;
    padding: 0;
    box-shadow: unset;
  }
`;

const LineBraker = styled.br`
  @media (min-width: 70.95em) {
    display: none;
  }
`;

const JoinUsBlock = () => {
  return (
    <JoinUs>
      <MissionGroup>
        <StyledBackgroundImage />
        <Mission>COME JOIN US</Mission>
        <Description>Let’s build the future of education together</Description>
        <Roles>
          <span>Roles open in</span>
          <LineBraker />
          <span>Design • Engineering • Product</span>
        </Roles>
        <Options
          label="See open postions"
          onClick={() => {
            window.open('http://careers.unacademy.com/');
          }}
        />
      </MissionGroup>
      <Image src={imageHelper.getImage('about/un.png')} />
    </JoinUs>
  );
};

export default JoinUsBlock;
